import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";

import HeroSectionComponent from "../components/landingPage/HeroSectionComponent";
import NoticeSectionComponent from "../components/landingPage/NoticeSectionComponent";
import MessagesSectionComponent from "../components/landingPage/MessagesSectionComponent";
import GetMembershipComponent from "../components/landingPage/GetMembershipComponent";
// import NewsSectionComponent from "../components/landingPage/NewsSectionComponent";
// import EventsSectionComponent from "../components/landingPage/EventsSectionComponent";

export default function LandingPage() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100 overflow-x-hidden">
      <HeaderComponent user={null} />

      <HeroSectionComponent />
      <GetMembershipComponent />
      <NoticeSectionComponent />
      <MessagesSectionComponent />
      {/* <NewsSectionComponent /> */}
      {/* <EventsSectionComponent /> */}

      <FooterComponent />
    </div>
  );
}
